import { render, staticRenderFns } from "./component-bbf0c1bb.vue?vue&type=template&id=bf499520&scoped=true&"
import script from "./component-bbf0c1bb.vue?vue&type=script&lang=js&"
export * from "./component-bbf0c1bb.vue?vue&type=script&lang=js&"
import style0 from "./component-bbf0c1bb.vue?vue&type=style&index=0&id=bf499520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf499520",
  null
  
)

export default component.exports